import React from 'react';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
const PROMISE = ['Smak', 'Kvalitet', 'Hantverk'];
export function Vision() {
  return <section className="w-full bg-warm py-28 md:py-40" data-id="element-165" data-mp="1g71r6xp9cpv3">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 md:grid-cols-2 md:gap-24 md:px-10" data-id="element-166" data-mp="1c8ce7684tabz">
        <Reveal data-id="element-167" data-mp="179hm1do9y9f7">
          <div className="overflow-hidden rounded-sm" data-id="element-168" data-mp="17a15iytkp5vc">
            <img src={IMAGES.dessertTable} alt="Elegant dessertbord med tårtor och bakverk" className="h-full w-full object-cover" data-id="element-169" data-mp="23yqoksgxs4iw" />
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-170" data-mp="1uwheu4thsf6k">
          <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-171" data-mp="1uzvhle62iqej">Vision</p>
          <h2 className="font-display text-3xl font-light leading-tight text-brun md:text-4xl" data-id="element-172" data-mp="1pyfu7fgf47sz">
            Den självklara destinationen för matupplevelser i Småland.
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-brun-soft" data-id="element-173" data-mp="ehxzpkwdsf8z">
            En plats där privatpersoner och företag hittar regionens främsta bagare, kockar,
            konditorier, caféer, dryckesproducenter och cateringföretag – samlade under ett
            varumärke med ett gemensamt löfte.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-174" data-mp="1w15nrjtp3f68">
            {PROMISE.map((word, i) => <React.Fragment key={word} data-id="element-175" data-mp="1mbm80n1a41fl" data-mpi={i}>
                <span className="font-display text-2xl italic text-skog md:text-3xl" data-id="element-176" data-mp="1majgqe01nwz5">{word}.</span>
                {i < PROMISE.length - 1 && <span className="text-terrakotta" data-id="element-177" data-mp="1r3m0xvixlu2o">/</span>}
              </React.Fragment>)}
          </div>

          <p className="mt-10 font-display text-xl italic text-bourgogne md:text-2xl" data-id="element-178" data-mp="1d935k41enqtv">
            Inte för alla. För dig som vill bjuda på något extra.
          </p>
        </Reveal>
      </div>
    </section>;
}